<template>
  <div class="app-container">
    <el-card>
      <div class="header d-flex justify-content-between align-items-center mb-3">
        <h2>Местные командировки (Год: {{ formData.trancheYear }})</h2>
        <div>
          <el-button @click="goBack" class="ms-2">Назад</el-button>
          <el-button type="primary" @click="saveData" :loading="saving">Сохранить</el-button>
        </div>
      </div>

      <div class="table-container mb-3" style="overflow-x: auto;" @paste="handlePaste" @keydown="handleKeydown">
        <table class="table table-bordered grid-table">
          <thead>
            <tr>
              <th rowspan="2">Категория должностей</th>
              <th rowspan="2">Количество работников</th>
              <th rowspan="2">Средняя норма возмещения суточных расходов на 1 человека*</th>
              <th rowspan="2">Средняя норма расходов по найму жилого помещения в сутки на 1 человека</th>
              <th rowspan="2">Средняя стоимость проезда в оба конца</th>
              <th rowspan="2">Всего</th>
              <th colspan="12" style="padding: 0;">в т.ч. по месяцам</th>
              <th rowspan="2"></th>
            </tr>
            <tr>
              <th>янв</th><th>фев</th><th>мар</th><th>апр</th><th>май</th><th>июн</th>
              <th>июл</th><th>авг</th><th>сен</th><th>окт</th><th>ноя</th><th>дек</th>
            </tr>
          </thead>
          <tbody>
            <tr class="calculated-row" style="font-weight: bold;">
              <td colspan="5" style="text-align: right;">ВСЕГО:</td>
              <td>{{ formatNumber(totalCalculatedSum) }}</td>
              <td>{{ formatNumber(totalMonths.janSum) }}</td>
              <td>{{ formatNumber(totalMonths.febSum) }}</td>
              <td>{{ formatNumber(totalMonths.marSum) }}</td>
              <td>{{ formatNumber(totalMonths.aprSum) }}</td>
              <td>{{ formatNumber(totalMonths.maySum) }}</td>
              <td>{{ formatNumber(totalMonths.junSum) }}</td>
              <td>{{ formatNumber(totalMonths.julSum) }}</td>
              <td>{{ formatNumber(totalMonths.augSum) }}</td>
              <td>{{ formatNumber(totalMonths.sepSum) }}</td>
              <td>{{ formatNumber(totalMonths.octSum) }}</td>
              <td>{{ formatNumber(totalMonths.novSum) }}</td>
              <td>{{ formatNumber(totalMonths.decSum) }}</td>
              <td></td>
            </tr>
            <tr v-for="(item, index) in formData.details" :key="item.uuid || index">
              <td>
                <el-select v-model="item.dictStaffCategoryId" size="small" placeholder="Выберите категорию" style="width: 100%">
                  <el-option
                    v-for="cat in staffCategories"
                    :key="cat.id"
                    :label="cat.nameRu"
                    :value="cat.id"
                  ></el-option>
                </el-select>
              </td>
              <td :data-item-idx="index" data-col="0"><el-input v-model="item.employeesCount" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcSum(item)" /></td>
              <td :data-item-idx="index" data-col="1"><el-input v-model="item.dailyAllowanceRate" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcSum(item)" /></td>
              <td :data-item-idx="index" data-col="2"><el-input v-model="item.accommodationCostPerDay" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcSum(item)" /></td>
              <td :data-item-idx="index" data-col="3"><el-input v-model="item.travelCostRoundTrip" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcSum(item)" /></td>
              <td class="calculated-row">{{ formatNumber(item.calculatedSum) }}</td>
              <td :data-item-idx="index" data-col="5"><el-input v-model="item.janSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="6"><el-input v-model="item.febSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="7"><el-input v-model="item.marSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="8"><el-input v-model="item.aprSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="9"><el-input v-model="item.maySum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="10"><el-input v-model="item.junSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="11"><el-input v-model="item.julSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="12"><el-input v-model="item.augSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="13"><el-input v-model="item.sepSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="14"><el-input v-model="item.octSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="15"><el-input v-model="item.novSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td :data-item-idx="index" data-col="16"><el-input v-model="item.decSum" size="small" :formatter="formatInputNumber" :parser="parseInputNumber" @input="recalcTotal(item)" /></td>
              <td>
                <el-button type="danger" size="small" @click="removeRow(index)">
                  <font-awesome-icon :icon="['fas', 'trash']" />
                </el-button>
              </td>
            </tr>
            <tr>
              <td colspan="19">
                <el-button type="success" size="small" @click="addRow">
                  <font-awesome-icon :icon="['fas', 'plus']"/> Добавить строку
                </el-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-card>
    <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
  </div>
</template>

<script>
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import service from "@/services/ueTripsLocalService";
import dictService from "@/services/dictionaryService";
import {handleGridKeydown} from "@/utils/gridKeyboardNav";

export default {
  name: "UeTripsLocalEditView",
  components: { VueLoading, FontAwesomeIcon },
  data() {
    return {
      isLoading: false,
      saving: false,
      uuid: this.$route.params.uuid,
      staffCategories: [],
      formData: {
        details: []
      }
    };
  },
  computed: {
    totalCalculatedSum() {
      if (!this.formData.details) return 0;
      return this.formData.details.reduce((acc, item) => acc + (parseFloat(item.calculatedSum) || 0), 0);
    },
    totalMonths() {
      const months = ["janSum", "febSum", "marSum", "aprSum", "maySum", "junSum", "julSum", "augSum", "sepSum", "octSum", "novSum", "decSum"];
      const totals = {};
      if (!this.formData.details) {
        months.forEach(m => totals[m] = 0);
        return totals;
      }
      months.forEach(m => {
        totals[m] = this.formData.details.reduce((acc, item) => acc + (parseFloat(item[m]) || 0), 0);
      });
      return totals;
    }
  },
  async mounted() {
    await this.loadDictionaries();
    this.loadData();
  },
  methods: {
    async loadDictionaries() {
      try {
        this.staffCategories = await dictService.getStaffCategories();
      } catch (e) {
        showErrorNotify('Ошибка при загрузке справочника категорий');
      }
    },
    formatNumber(val) {
      if (val === undefined || val === null || val === '' || isNaN(val)) return '0,00';
      const formatted = parseFloat(val).toFixed(2);
      const parts = formatted.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',');
    },
    formatInputNumber(value) {
      if (value === undefined || value === null || value === '') return '';
      const parts = value.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join(',');
    },
    parseInputNumber(value) {
      if (!value) return '';
      let parsed = value.toString().replace(',', '.');
      parsed = parsed.replace(/[^\d.]/g, '');
      const parts = parsed.split('.');
      if (parts.length > 2) {
        parsed = parts[0] + '.' + parts.slice(1).join('');
      }
      return parsed;
    },
    async loadData() {
      if (!this.uuid) return;
      this.isLoading = true;
      try {
        const data = await service.getById(this.uuid);
        if (data) {
          if (!data.details) data.details = [];
          this.formData = data;
        }
      } catch (e) {
        showErrorNotify('Ошибка при загрузке данных');
      } finally {
        this.isLoading = false;
      }
    },
    recalcSum(item) {
        // Optional calculation based on logic if required
    },
    recalcTotal(item) {
      const months = ["janSum", "febSum", "marSum", "aprSum", "maySum", "junSum", "julSum", "augSum", "sepSum", "octSum", "novSum", "decSum"];
      const sum = months.reduce((acc, m) => acc + (parseFloat(item[m]) || 0), 0);
      item.calculatedSum = sum.toFixed(2);
    },
    addRow() {
      if (!this.formData.details) this.formData.details = [];
      this.formData.details.push({
        dictStaffCategoryId: null,
        positionCategory: '',
        employeesCount: '',
        dailyAllowanceRate: '',
        accommodationCostPerDay: '',
        travelCostRoundTrip: '',
        calculatedSum: '',
        janSum: '', febSum: '', marSum: '', aprSum: '',
        maySum: '', junSum: '', julSum: '', augSum: '',
        sepSum: '', octSum: '', novSum: '', decSum: ''
      });
    },
    removeRow(index) {
      if (confirm('Удалить строку?')) {
        this.formData.details.splice(index, 1);
      }
    },
    async saveData() {
      this.saving = true;
      try {
        const result = await service.save(this.formData);
        this.formData = result;
        showSuccessNotify('Данные успешно сохранены');
      } catch (e) {
        showErrorNotify('Ошибка при сохранении');
      } finally {
        this.saving = false;
      }
    },
    goBack() {
      this.$router.push('/expenses/trips-local');
    },
    handleKeydown(event) {
      handleGridKeydown(event, this.$el);
    },
    handlePaste(event) {
      const target = event.target;
      if (!target || target.tagName !== 'INPUT') return;

      const td = target.closest('td');
      if (!td) return;

      const startItemIdx = parseInt(td.dataset.itemIdx);
      const startCol = parseInt(td.dataset.col);

      if (isNaN(startItemIdx) || isNaN(startCol)) return;

      const clipboardData = event.clipboardData || window.clipboardData;
      if (!clipboardData) return;

      const text = clipboardData.getData('text/plain');
      if (!text) return;

      const rows = text.split(/\r?\n/).filter(r => r.trim() !== '');
      if (rows.length <= 1 && !rows[0].includes('\t')) return;

      event.preventDefault();

      const COL_FIELDS = [
        'employeesCount', 'dailyAllowanceRate', 'accommodationCostPerDay', 'travelCostRoundTrip', 'SKIP',
        'janSum', 'febSum', 'marSum', 'aprSum', 'maySum', 'junSum',
        'julSum', 'augSum', 'sepSum', 'octSum', 'novSum', 'decSum'
      ];

      let currentItemIdx = startItemIdx;

      for (let r = 0; r < rows.length; r++) {
        const cols = rows[r].split('\t');
        
        if (currentItemIdx >= this.formData.details.length) break;
        let currentItem = this.formData.details[currentItemIdx];

        for (let c = 0; c < cols.length; c++) {
          const colIdx = startCol + c;
          if (colIdx >= COL_FIELDS.length) break;

          const field = COL_FIELDS[colIdx];
          if (field === 'SKIP') continue;

          const rawVal = String(cols[c]).replace(/\s/g, '').replace(',', '.');
          
          const num = parseFloat(rawVal);
          currentItem[field] = isNaN(num) || num === 0 ? '' : num;
        }

        this.recalcSum(currentItem);
        this.recalcTotal(currentItem);
        currentItemIdx++;
      }

      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
.grid-table th { font-size: 13px; vertical-align: middle; text-align: center; background-color: #e8f5e9 !important; }
.grid-table td { font-size: 13px; vertical-align: middle; }
.calculated-row td { background-color: #e8f5e9 !important; text-align: center; font-weight: bold; }
:deep(.el-input__inner) { font-size: 13px; }
</style>
